// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .callender-left-wrapper {
  width: 15rem;
} */
.callernder-top-wrapper {
  display: flex;
}
.duration h4 {
  font-size: 22px;
  font-weight: 700;
  line-height: 26px;
  letter-spacing: 0.03em;
  color: #0d5c9c;
}
.choose-slot {
  width: 150px;
  border-radius: 8px;
  border: 1px solid #e7e7e7;
  background-color: #ffffff;
  padding: 12px 10px;
  cursor: pointer;
}
.choose-slot h4 {
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.03em;
  text-align: center;
  color: #b1b1b1;
}
.calender-bottom-wrapper h4 {
  font-size: 20px;
  font-weight: 500;
  line-height: 26px;
  letter-spacing: 0.03em;
  color: #0d5c9c;
}
.back-wrapper img {
  width: 20px;
}

.callender-wrapper {
  width: max-content;
  border-radius: 12px;
  position: relative;
  margin-top: 2rem;
}
.callender-page {
  display: flex;
  align-items: center;
  border-right: 1px solid #9a9a9a33;
}
.calendar-container p {
  font-size: 16px;
  font-weight: 400;
  line-height: 21px;
  color: #727272;
  padding: 0px 16px;
}
.choose-slot.selected {
  background-color: #0d5c9c;
  color: white;
  box-shadow: 0px 2px 12px 0px #4279be80;
}
.choose-slot.selected h4 {
  color: white;
}
.calender-container-wrapper {
  display: flex;
}
.callender-left-wrapper {
  background: linear-gradient(358.63deg, #4aaeff 1.01%, #0d5c9c 98.77%);
  border-left: 1px solid #daefff;
  border-radius: 16px 0px 0px 0px;
  border: 0px 0px 0px 1px;
  padding: 50px 20px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 15rem;
}
.callender-left-wrapper.confirmation-step {
  background: linear-gradient(358.63deg, #ffffff 1.01%, #ffffff 98.77%);
  width: 100%;
  padding: 30px 50px 30px 50px;
}
.duration {
  display: flex;
  background-color: #e5f0ff;
  width: 10rem;
  padding: 12px 10px;
  gap: 10px;
  align-items: center;
  border-radius: 5px;
  height: max-content;
  margin-bottom: 22px;
}

.scheduled-demo p {
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: #ececec;
}

.selected-slot {
  background-color: #e5f0ff;
  padding: 20px;
  border-radius: 12px;
}

.selected-date {
  padding-bottom: 10px;
}

.selected-date p {
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  margin-bottom: 5px;
}

.selected-date h3 {
  font-size: 20px;
  font-weight: 500;
  line-height: 26px;
}

.slot-wrapper-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.slot-top-wrapper {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.middle-book-details {
  display: flex;
  flex-direction: column;
}

.custom-width {
  width: 500px;
  background-color: #f8fcff;
  border: 1px solid #0d5c9c;
  padding: 0;
  border-radius: 12px;
}

.check-box {
  border: 1px solid #000000;
  width: 25px;
  height: 25px;
  border-radius: 8px;
}

.answer-wrapper p {
  font-size: 20px;
  font-weight: 500;
  line-height: 26px;
}

.bottom-book-details p {
  font-size: 20px;
  font-weight: 400;
  line-height: 26px;
  color: #333333;
  padding-bottom: 10px;
}

.top-book-details h3 {
  font-size: 24px;
  font-weight: 600;
  line-height: 30px;
}

.top-book-details p {
  font-size: 20px;
  font-weight: 400;
  line-height: 30px;
  color: #919191;
}

.answer-wrapper {
  display: flex;
  gap: 30px;
}

.book-details {
  padding: 60px 60px 60px 60px;
  display: flex;
  flex-direction: column;
  gap: 50px;
}

.check-box.checked {
  background-color: #0d5c9c;
  /* Change to your desired color */
  border-color: #0d5c9c;
}

.yes-wrapper,
.no-wrapper {
  cursor: pointer;
  display: flex;
  gap: 20px;
}

.yes-wrapper.selected,
.no-wrapper.selected {
  font-weight: bold;
  color: #0d5c9c;
  /* Change to your desired color */
}

.slot-confirmation {
  background-color: #f0f0f0;
  border: 1px solid #d1d1d1;
  width: max-content;
  display: flex;
  border-radius: 12px;
  padding: 15px;
  gap: 50px;
}
.confirmation-container {
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-items: center;
  gap: 30px;
}
.confirmation-container img {
  width: 85px;
}
.confirmation-header h1 {
  font-size: 36px;
  font-weight: 700;
  line-height: 42px;
  text-align: center;
  padding-bottom: 15px;
}
.confirmation-header p {
  font-size: 20px;
  font-weight: 400;
  line-height: 24.2px;
  text-align: center;
  color: #7c7c7c;
  width: 99%;
}
.get-back-home {
  border: 1px solid #4279be;
  background: #e5f0ff;
  width: max-content;
  padding: 15px 10px;
  border-radius: 8px;
  width: 10rem;
  cursor: pointer;
}
.get-back-home p {
  text-align: center;
  font-size: 20px;
  font-weight: 500;
  line-height: 26px;
  letter-spacing: 0.03em;
  color: #0d5c9c;
}
.resend-email {
  width: max-content;
  padding: 15px 10px;
  border-radius: 8px;
  width: 10rem;
}
.resend-email p {
  text-align: center;
  font-size: 20px;
  font-weight: 500;
  line-height: 26px;
  letter-spacing: 0.03em;
  color: #0d5c9c;
}
.confirmation-bottom {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding-bottom: 30px;
}
.calender-right-wrapper {
  background: linear-gradient(180.67deg, #ffffff 0.58%, #d5ecff 161.98%);
  padding: 60px 35px;
  display: flex;
  flex-direction: column;
  gap: 30px;
  align-items: center;
}
.scheduled-demo h3 {
  font-size: 24px;
  font-weight: 600;
  line-height: 30px;
  color: #ffffff;
  padding-bottom: 10px;
}
.calendar-container {
  padding: 1rem 3.3rem 3.3rem 0;
}
.next-wrapper {
  width: 7rem;
  padding: 10px 10px;
  border-radius: 8px;
  display: flex;
  gap: 20px;
  justify-content: center;
  border: 1px solid #4279be;
  background-color: #e5f0ff;
  cursor: pointer;
}
.back-wrapper {
  width: 7rem;
  padding: 10px 10px;
  border-radius: 8px;
  display: flex;
  gap: 20px;
  justify-content: center;
  cursor: pointer;
}
.cross-wrapper {
  background-color: rgb(254 226 226);
  width: max-content;
  padding: 15px;
  border-radius: 32px;
}
.back-wrapper {
  width: 10rem;
  padding: 12px 10px;
  border-radius: 8px;
  display: flex;
  gap: 20px;
  justify-content: center;
  cursor: pointer;
}
.error h3 {
  font-size: 1.125rem;
  font-weight: 500;
  line-height: 1.5rem;
}
.error p {
  color: rgb(107 114 128);
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.error-text p {
  color: red;
  font-size: 14px;
  line-height: 20px;
}
.book-img img {
  width: 200px;
}
.error h4 {
  color: white;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 700;
  text-align: center;
  cursor: pointer;
}
.okay-wrapper {
  background-color: rgb(220 38 38);
  width: 350px;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  border-radius: 0.375rem;
  border-width: 1px;
}
.error {
  background-color: rgb(255 255 255);
  padding: 10px;
  width: max-content;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  position: absolute;
  border-radius: 0.5rem;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
}
.blur-elements {
  filter: blur(5px);
  pointer-events: none;
}
.time-zone input {
  border: none;
  font-size: 22px;
  font-weight: 700;
  line-height: 26px;
  letter-spacing: 0.03em;
  color: #0d5c9c;
  width: 100%;
  background-color: #e5f0ff;
}
.time-zone input:focus-visible {
  outline: none;
}
.time-zone {
  align-items: center;
  display: flex;
  gap: 7px;
}
.time-zone-wrapper {
  display: flex;
  padding: 12px 10px;
  background-color: #e5f0ff;
  border-radius: 5px;
  position: relative;
  width: 10rem;
}
.time-zone {
  color: #000000;
}
.error-active {
  .callernder-top-wrapper,
  .calender-container-wrapper {
    filter: blur(5px);
    pointer-events: none;
  }
}
::placeholder {
  color: #0d5c9c;
}
.all-time-zone-wrapper {
  position: absolute;
  top: 20px;
  background-color: white;
  padding: 10px 0px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-y: auto;
  height: 180px;
  top: 65px;
  left: 0;
}
.time-zone-item {
  color: #0d5c9c;
  font-size: 1rem;
  line-height: 1.15rem;
  cursor: pointer;
  padding: 10px 20px;
}
.time-zone-item:hover {
  background-color: #d1d5db;
}
.scheduled-demo h4 {
  font-size: 16px;
  line-height: 22px;
  font-weight: 500;
  color: #ececec;
  padding-bottom: 20px;
}
.calender-right-wrapper h2 {
  font-size: 22px;
  line-height: 28px;
  font-weight: 500;
}
.bottom-callender-conatiner {
  width: 100%;
  display: flex;
  justify-content: end;
  gap: 20px;
}
.next-wrapper h4 {
  font-size: 20px;
  font-weight: 500;
  line-height: 26px;
  letter-spacing: 0.03em;
  color: #0d5c9c;
}
.back-wrapper h4 {
  font-size: 20px;
  font-weight: 500;
  line-height: 26px;
  letter-spacing: 0.03em;
  color: #0d5c9c;
}

.slots-wrapper {
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
}
.book-wrapper {
  display: flex;
  flex-direction: column;
  gap: 15px;
}
.option-box {
  width: 25px;
  height: 25px;
  border: 1px solid rgba(0, 0, 0, 1);
  border-radius: 5px;
}
.option p {
  color: rgba(49, 49, 49, 1);
  font-size: 16px;
  line-height: 22px;
}
.option {
  display: flex;
  gap: 10px;
  align-items: center;
}
.option-wrapper {
  display: flex;
  flex-direction: column;
  gap: 15px;
  flex-wrap: wrap;
  height: 52vh;
  width: 50vw;
  justify-content: flex-start;
}
.company-details {
  padding-bottom: 30px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.company-container {
  padding: 60px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: min-content;
}
.company-top-wrapper p {
  font-size: 20px;
  font-weight: 400;
  line-height: 30px;
  color: #919191;
}
.company-top-wrapper h2 {
  font-size: 24px;
  font-weight: 600;
  line-height: 30px;
}
.status-wrapper p {
  color: rgba(51, 51, 51, 1);
  font-size: 20px;
  font-weight: 400;
  line-height: 30px;
}
.option.selected .option-box {
  background-color: #0d5c9c;
  border-color: #0d5c9c;
}
.react-calendar__tile:disabled {
  background-color: #fff;
}
@media (max-width: 1440px) {
  .company-container {
    padding: 40px;
  }
}
@media (max-width: 1072px) {
  .scheduled-demo {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .duration-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .callender-left-wrapper.confirmation-step {
    width: auto;
  }
  .book-img img {
    width: 150px;
  }

  .callernder-top-wrapper {
    flex-direction: column;
  }

  .duration img {
    width: 20px;
  }

  .callender-left-wrapper {
    width: auto;
    border-radius: 16px 16px 0px 0px;
  }

  .callernder-top-wrapper {
    display: flex;
    flex-direction: column;
  }

  .callender-left-wrapper {
    flex-direction: row-reverse;
    align-items: center;
    justify-content: space-between;
  }

  .slot-wrapper-container {
    flex-direction: row;
    width: 100%;
  }

  .slot-top-wrapper {
    flex-direction: column;
    gap: 10px;
    align-items: center;
    justify-content: center;
  }
  .option-wrapper {
    height: 40vh;
    overflow-y: auto;
    flex-direction: row;
  }
  .scheduled-demo-wrapper {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
  .scheduled-demo h4 {
    width: 160px;
    padding-bottom: 0;
  }
  .callender-left-wrapper {
    padding: 30px 40px 30px 60px;
  }
  .option p {
    width: 350px;
  }
  .duration {
    width: 7rem;
  }
  .time-zone-wrapper {
    width: 7rem;
  }
  .all-time-zone-wrapper {
    right: 0;
    left: auto;
    box-shadow: 0px 2px 12px 0px #00000026;
    z-index: 1000;
  }
}

@media (max-width: 820px) {
  .callender-left-wrapper {
    padding: 20px 35px 20px 20px;
  }
  .slots-wrapper {
    overflow-x: auto;
    width: 50vw;
    flex-direction: row;
  }
  .calender-bottom-wrapper {
    padding: 15px 15px;
  }
  .calender-container-wrapper {
    flex-direction: column;
  }
  .calender-right-wrapper {
    flex-direction: row;
  }
  .calender-right-wrapper {
    padding: 0px 0px 15px 0px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    flex-direction: column;
  }
  .calendar-container {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .choose-slot h4 {
    min-width: 100px;
  }
  .option-wrapper {
    width: auto;
    height: 30vh;
  }
}
@media (max-width: 604px) {
  .company-container {
    padding: 20px;
  }
  .time-zone-wrapper {
    width: 7rem;
  }
  .slot-confirmation {
    flex-direction: column;
    gap: 0;
  }
  .duration img {
    width: 20px;
  }
  .confirmation-header h1 {
    font-size: 28px;
    line-height: 34px;
  }
  .calendar-container {
    padding: 20px 0px 20px 0px;
  }
  .custom-width {
    width: 400px;
  }
  .selected-slot {
    padding: 5px;
  }
  .duration {
    width: 7rem;
  }
  .slot-top-wrapper {
    align-items: start;
  }
  .book-details {
    padding: 40px;
  }
  .selected-date h3 {
    font-size: 18px;
    font-weight: 500;
    line-height: 24px;
  }
  callender-left-wrapper.confirmation-step {
    padding: 30px 25px 30px 25px;
  }
  .option-wrapper {
    width: auto;
  }
}
@media (max-width: 576px) {
  .callender-page {
    border-right: none;
    padding: 0;
  }
  .callender-wrapper {
    width: 100%;
  }
  .top-callender-container {
    width: 100%;
  }
}
@media (min-width: 577px) {
  .react-calendar,
  .react-calendar *,
  .react-calendar *:before,
  .react-calendar *:after {
    font-size: 1.3rem;
  }
  .react-calendar__navigation__label__labelText {
    font-size: 1.8rem;
  }
}
@media (max-width: 464px) {
  .time-zone input {
    font-size: 18px;
    line-height: 24px;
  }
  .duration h4 {
    font-size: 18px;
    line-height: 24px;
  }
  .scheduled-demo h4 {
    font-size: 14px;
    line-height: 20px;
  }
  .scheduled-demo h3 {
    font-size: 22px;
    line-height: 28px;
  }
  .option p {
    width: 250px;
  }
  .callender-left-wrapper {
    padding: 20px 20px 20px 20px;
  }
  .slots-wrapper {
    width: 80vw;
  }
  .scheduled-demo h3 {
    padding-bottom: 5px;
  }
  .choose-slot {
    width: 110px;
  }
  .next-wrapper {
    width: 8rem;
  }
  .back-wrapper {
    width: 8rem;
  }
  .custom-width {
    width: 300px;
  }
  .callender-left-wrapper.confirmation-step {
    padding: 20px;
  }
}
/* @media (max-width: 400px) {
  .calender-right-wrapper{
    width: 36vh;
  } */
/* } */
`, "",{"version":3,"sources":["webpack://./src/components/Calendar/Calendar.css"],"names":[],"mappings":"AAAA;;GAEG;AACH;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,iCAAiC;AACnC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,sCAAsC;AACxC;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,qEAAqE;EACrE,8BAA8B;EAC9B,+BAA+B;EAC/B,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;AACA;EACE,qEAAqE;EACrE,WAAW;EACX,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;;EAEE,eAAe;EACf,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,iBAAiB;EACjB,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,oBAAoB;AACtB;AACA;EACE,sEAAsE;EACtE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,UAAU;EACV,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,gCAAgC;EAChC,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,kCAAkC;EAClC,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,QAAQ;AACV;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE;;IAEE,iBAAiB;IACjB,oBAAoB;EACtB;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,OAAO;AACT;AACA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,aAAa;EACb,oBAAoB;EACpB,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;EACf,YAAY;EACZ,WAAW;EACX,2BAA2B;AAC7B;AACA;EACE,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,8BAA8B;EAChC;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,8BAA8B;EAChC;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,gCAAgC;EAClC;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,2BAA2B;IAC3B,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,WAAW;EACb;EACA;IACE,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,QAAQ;IACR,UAAU;IACV,sCAAsC;IACtC,aAAa;EACf;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,gBAAgB;IAChB,WAAW;IACX,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;IACzB,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,sBAAsB;EACxB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,YAAY;EACd;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,sBAAsB;IACtB,MAAM;EACR;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,kBAAkB;IAClB,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;AACF;AACA;EACE;;;;IAIE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,WAAW;EACb;EACA;IACE,mBAAmB;EACrB;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;AACF;AACA;;;KAGK;AACL,MAAM","sourcesContent":["/* .callender-left-wrapper {\n  width: 15rem;\n} */\n.callernder-top-wrapper {\n  display: flex;\n}\n.duration h4 {\n  font-size: 22px;\n  font-weight: 700;\n  line-height: 26px;\n  letter-spacing: 0.03em;\n  color: #0d5c9c;\n}\n.choose-slot {\n  width: 150px;\n  border-radius: 8px;\n  border: 1px solid #e7e7e7;\n  background-color: #ffffff;\n  padding: 12px 10px;\n  cursor: pointer;\n}\n.choose-slot h4 {\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 24px;\n  letter-spacing: 0.03em;\n  text-align: center;\n  color: #b1b1b1;\n}\n.calender-bottom-wrapper h4 {\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 26px;\n  letter-spacing: 0.03em;\n  color: #0d5c9c;\n}\n.back-wrapper img {\n  width: 20px;\n}\n\n.callender-wrapper {\n  width: max-content;\n  border-radius: 12px;\n  position: relative;\n  margin-top: 2rem;\n}\n.callender-page {\n  display: flex;\n  align-items: center;\n  border-right: 1px solid #9a9a9a33;\n}\n.calendar-container p {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 21px;\n  color: #727272;\n  padding: 0px 16px;\n}\n.choose-slot.selected {\n  background-color: #0d5c9c;\n  color: white;\n  box-shadow: 0px 2px 12px 0px #4279be80;\n}\n.choose-slot.selected h4 {\n  color: white;\n}\n.calender-container-wrapper {\n  display: flex;\n}\n.callender-left-wrapper {\n  background: linear-gradient(358.63deg, #4aaeff 1.01%, #0d5c9c 98.77%);\n  border-left: 1px solid #daefff;\n  border-radius: 16px 0px 0px 0px;\n  border: 0px 0px 0px 1px;\n  padding: 50px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  width: 15rem;\n}\n.callender-left-wrapper.confirmation-step {\n  background: linear-gradient(358.63deg, #ffffff 1.01%, #ffffff 98.77%);\n  width: 100%;\n  padding: 30px 50px 30px 50px;\n}\n.duration {\n  display: flex;\n  background-color: #e5f0ff;\n  width: 10rem;\n  padding: 12px 10px;\n  gap: 10px;\n  align-items: center;\n  border-radius: 5px;\n  height: max-content;\n  margin-bottom: 22px;\n}\n\n.scheduled-demo p {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 18px;\n  color: #ececec;\n}\n\n.selected-slot {\n  background-color: #e5f0ff;\n  padding: 20px;\n  border-radius: 12px;\n}\n\n.selected-date {\n  padding-bottom: 10px;\n}\n\n.selected-date p {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 18px;\n  margin-bottom: 5px;\n}\n\n.selected-date h3 {\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 26px;\n}\n\n.slot-wrapper-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 100%;\n}\n\n.slot-top-wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.middle-book-details {\n  display: flex;\n  flex-direction: column;\n}\n\n.custom-width {\n  width: 500px;\n  background-color: #f8fcff;\n  border: 1px solid #0d5c9c;\n  padding: 0;\n  border-radius: 12px;\n}\n\n.check-box {\n  border: 1px solid #000000;\n  width: 25px;\n  height: 25px;\n  border-radius: 8px;\n}\n\n.answer-wrapper p {\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 26px;\n}\n\n.bottom-book-details p {\n  font-size: 20px;\n  font-weight: 400;\n  line-height: 26px;\n  color: #333333;\n  padding-bottom: 10px;\n}\n\n.top-book-details h3 {\n  font-size: 24px;\n  font-weight: 600;\n  line-height: 30px;\n}\n\n.top-book-details p {\n  font-size: 20px;\n  font-weight: 400;\n  line-height: 30px;\n  color: #919191;\n}\n\n.answer-wrapper {\n  display: flex;\n  gap: 30px;\n}\n\n.book-details {\n  padding: 60px 60px 60px 60px;\n  display: flex;\n  flex-direction: column;\n  gap: 50px;\n}\n\n.check-box.checked {\n  background-color: #0d5c9c;\n  /* Change to your desired color */\n  border-color: #0d5c9c;\n}\n\n.yes-wrapper,\n.no-wrapper {\n  cursor: pointer;\n  display: flex;\n  gap: 20px;\n}\n\n.yes-wrapper.selected,\n.no-wrapper.selected {\n  font-weight: bold;\n  color: #0d5c9c;\n  /* Change to your desired color */\n}\n\n.slot-confirmation {\n  background-color: #f0f0f0;\n  border: 1px solid #d1d1d1;\n  width: max-content;\n  display: flex;\n  border-radius: 12px;\n  padding: 15px;\n  gap: 50px;\n}\n.confirmation-container {\n  display: flex;\n  flex-direction: column;\n  justify-items: center;\n  align-items: center;\n  gap: 30px;\n}\n.confirmation-container img {\n  width: 85px;\n}\n.confirmation-header h1 {\n  font-size: 36px;\n  font-weight: 700;\n  line-height: 42px;\n  text-align: center;\n  padding-bottom: 15px;\n}\n.confirmation-header p {\n  font-size: 20px;\n  font-weight: 400;\n  line-height: 24.2px;\n  text-align: center;\n  color: #7c7c7c;\n  width: 99%;\n}\n.get-back-home {\n  border: 1px solid #4279be;\n  background: #e5f0ff;\n  width: max-content;\n  padding: 15px 10px;\n  border-radius: 8px;\n  width: 10rem;\n  cursor: pointer;\n}\n.get-back-home p {\n  text-align: center;\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 26px;\n  letter-spacing: 0.03em;\n  color: #0d5c9c;\n}\n.resend-email {\n  width: max-content;\n  padding: 15px 10px;\n  border-radius: 8px;\n  width: 10rem;\n}\n.resend-email p {\n  text-align: center;\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 26px;\n  letter-spacing: 0.03em;\n  color: #0d5c9c;\n}\n.confirmation-bottom {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 20px;\n  padding-bottom: 30px;\n}\n.calender-right-wrapper {\n  background: linear-gradient(180.67deg, #ffffff 0.58%, #d5ecff 161.98%);\n  padding: 60px 35px;\n  display: flex;\n  flex-direction: column;\n  gap: 30px;\n  align-items: center;\n}\n.scheduled-demo h3 {\n  font-size: 24px;\n  font-weight: 600;\n  line-height: 30px;\n  color: #ffffff;\n  padding-bottom: 10px;\n}\n.calendar-container {\n  padding: 1rem 3.3rem 3.3rem 0;\n}\n.next-wrapper {\n  width: 7rem;\n  padding: 10px 10px;\n  border-radius: 8px;\n  display: flex;\n  gap: 20px;\n  justify-content: center;\n  border: 1px solid #4279be;\n  background-color: #e5f0ff;\n  cursor: pointer;\n}\n.back-wrapper {\n  width: 7rem;\n  padding: 10px 10px;\n  border-radius: 8px;\n  display: flex;\n  gap: 20px;\n  justify-content: center;\n  cursor: pointer;\n}\n.cross-wrapper {\n  background-color: rgb(254 226 226);\n  width: max-content;\n  padding: 15px;\n  border-radius: 32px;\n}\n.back-wrapper {\n  width: 10rem;\n  padding: 12px 10px;\n  border-radius: 8px;\n  display: flex;\n  gap: 20px;\n  justify-content: center;\n  cursor: pointer;\n}\n.error h3 {\n  font-size: 1.125rem;\n  font-weight: 500;\n  line-height: 1.5rem;\n}\n.error p {\n  color: rgb(107 114 128);\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n}\n.error-text p {\n  color: red;\n  font-size: 14px;\n  line-height: 20px;\n}\n.book-img img {\n  width: 200px;\n}\n.error h4 {\n  color: white;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  font-weight: 700;\n  text-align: center;\n  cursor: pointer;\n}\n.okay-wrapper {\n  background-color: rgb(220 38 38);\n  width: 350px;\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  border-radius: 0.375rem;\n  border-width: 1px;\n}\n.error {\n  background-color: rgb(255 255 255);\n  padding: 10px;\n  width: max-content;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 15px;\n  position: absolute;\n  border-radius: 0.5rem;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  cursor: pointer;\n}\n.blur-elements {\n  filter: blur(5px);\n  pointer-events: none;\n}\n.time-zone input {\n  border: none;\n  font-size: 22px;\n  font-weight: 700;\n  line-height: 26px;\n  letter-spacing: 0.03em;\n  color: #0d5c9c;\n  width: 100%;\n  background-color: #e5f0ff;\n}\n.time-zone input:focus-visible {\n  outline: none;\n}\n.time-zone {\n  align-items: center;\n  display: flex;\n  gap: 7px;\n}\n.time-zone-wrapper {\n  display: flex;\n  padding: 12px 10px;\n  background-color: #e5f0ff;\n  border-radius: 5px;\n  position: relative;\n  width: 10rem;\n}\n.time-zone {\n  color: #000000;\n}\n.error-active {\n  .callernder-top-wrapper,\n  .calender-container-wrapper {\n    filter: blur(5px);\n    pointer-events: none;\n  }\n}\n::placeholder {\n  color: #0d5c9c;\n}\n.all-time-zone-wrapper {\n  position: absolute;\n  top: 20px;\n  background-color: white;\n  padding: 10px 0px;\n  border-radius: 10px;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  overflow-y: auto;\n  height: 180px;\n  top: 65px;\n  left: 0;\n}\n.time-zone-item {\n  color: #0d5c9c;\n  font-size: 1rem;\n  line-height: 1.15rem;\n  cursor: pointer;\n  padding: 10px 20px;\n}\n.time-zone-item:hover {\n  background-color: #d1d5db;\n}\n.scheduled-demo h4 {\n  font-size: 16px;\n  line-height: 22px;\n  font-weight: 500;\n  color: #ececec;\n  padding-bottom: 20px;\n}\n.calender-right-wrapper h2 {\n  font-size: 22px;\n  line-height: 28px;\n  font-weight: 500;\n}\n.bottom-callender-conatiner {\n  width: 100%;\n  display: flex;\n  justify-content: end;\n  gap: 20px;\n}\n.next-wrapper h4 {\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 26px;\n  letter-spacing: 0.03em;\n  color: #0d5c9c;\n}\n.back-wrapper h4 {\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 26px;\n  letter-spacing: 0.03em;\n  color: #0d5c9c;\n}\n\n.slots-wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  align-items: center;\n}\n.book-wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n.option-box {\n  width: 25px;\n  height: 25px;\n  border: 1px solid rgba(0, 0, 0, 1);\n  border-radius: 5px;\n}\n.option p {\n  color: rgba(49, 49, 49, 1);\n  font-size: 16px;\n  line-height: 22px;\n}\n.option {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n.option-wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  flex-wrap: wrap;\n  height: 52vh;\n  width: 50vw;\n  justify-content: flex-start;\n}\n.company-details {\n  padding-bottom: 30px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n.company-container {\n  padding: 60px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: min-content;\n}\n.company-top-wrapper p {\n  font-size: 20px;\n  font-weight: 400;\n  line-height: 30px;\n  color: #919191;\n}\n.company-top-wrapper h2 {\n  font-size: 24px;\n  font-weight: 600;\n  line-height: 30px;\n}\n.status-wrapper p {\n  color: rgba(51, 51, 51, 1);\n  font-size: 20px;\n  font-weight: 400;\n  line-height: 30px;\n}\n.option.selected .option-box {\n  background-color: #0d5c9c;\n  border-color: #0d5c9c;\n}\n.react-calendar__tile:disabled {\n  background-color: #fff;\n}\n@media (max-width: 1440px) {\n  .company-container {\n    padding: 40px;\n  }\n}\n@media (max-width: 1072px) {\n  .scheduled-demo {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n  }\n  .duration-wrapper {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n  }\n  .callender-left-wrapper.confirmation-step {\n    width: auto;\n  }\n  .book-img img {\n    width: 150px;\n  }\n\n  .callernder-top-wrapper {\n    flex-direction: column;\n  }\n\n  .duration img {\n    width: 20px;\n  }\n\n  .callender-left-wrapper {\n    width: auto;\n    border-radius: 16px 16px 0px 0px;\n  }\n\n  .callernder-top-wrapper {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .callender-left-wrapper {\n    flex-direction: row-reverse;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  .slot-wrapper-container {\n    flex-direction: row;\n    width: 100%;\n  }\n\n  .slot-top-wrapper {\n    flex-direction: column;\n    gap: 10px;\n    align-items: center;\n    justify-content: center;\n  }\n  .option-wrapper {\n    height: 40vh;\n    overflow-y: auto;\n    flex-direction: row;\n  }\n  .scheduled-demo-wrapper {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n  }\n  .scheduled-demo h4 {\n    width: 160px;\n    padding-bottom: 0;\n  }\n  .callender-left-wrapper {\n    padding: 30px 40px 30px 60px;\n  }\n  .option p {\n    width: 350px;\n  }\n  .duration {\n    width: 7rem;\n  }\n  .time-zone-wrapper {\n    width: 7rem;\n  }\n  .all-time-zone-wrapper {\n    right: 0;\n    left: auto;\n    box-shadow: 0px 2px 12px 0px #00000026;\n    z-index: 1000;\n  }\n}\n\n@media (max-width: 820px) {\n  .callender-left-wrapper {\n    padding: 20px 35px 20px 20px;\n  }\n  .slots-wrapper {\n    overflow-x: auto;\n    width: 50vw;\n    flex-direction: row;\n  }\n  .calender-bottom-wrapper {\n    padding: 15px 15px;\n  }\n  .calender-container-wrapper {\n    flex-direction: column;\n  }\n  .calender-right-wrapper {\n    flex-direction: row;\n  }\n  .calender-right-wrapper {\n    padding: 0px 0px 15px 0px;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    flex-direction: column;\n  }\n  .calendar-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n  .choose-slot h4 {\n    min-width: 100px;\n  }\n  .option-wrapper {\n    width: auto;\n    height: 30vh;\n  }\n}\n@media (max-width: 604px) {\n  .company-container {\n    padding: 20px;\n  }\n  .time-zone-wrapper {\n    width: 7rem;\n  }\n  .slot-confirmation {\n    flex-direction: column;\n    gap: 0;\n  }\n  .duration img {\n    width: 20px;\n  }\n  .confirmation-header h1 {\n    font-size: 28px;\n    line-height: 34px;\n  }\n  .calendar-container {\n    padding: 20px 0px 20px 0px;\n  }\n  .custom-width {\n    width: 400px;\n  }\n  .selected-slot {\n    padding: 5px;\n  }\n  .duration {\n    width: 7rem;\n  }\n  .slot-top-wrapper {\n    align-items: start;\n  }\n  .book-details {\n    padding: 40px;\n  }\n  .selected-date h3 {\n    font-size: 18px;\n    font-weight: 500;\n    line-height: 24px;\n  }\n  callender-left-wrapper.confirmation-step {\n    padding: 30px 25px 30px 25px;\n  }\n  .option-wrapper {\n    width: auto;\n  }\n}\n@media (max-width: 576px) {\n  .callender-page {\n    border-right: none;\n    padding: 0;\n  }\n  .callender-wrapper {\n    width: 100%;\n  }\n  .top-callender-container {\n    width: 100%;\n  }\n}\n@media (min-width: 577px) {\n  .react-calendar,\n  .react-calendar *,\n  .react-calendar *:before,\n  .react-calendar *:after {\n    font-size: 1.3rem;\n  }\n  .react-calendar__navigation__label__labelText {\n    font-size: 1.8rem;\n  }\n}\n@media (max-width: 464px) {\n  .time-zone input {\n    font-size: 18px;\n    line-height: 24px;\n  }\n  .duration h4 {\n    font-size: 18px;\n    line-height: 24px;\n  }\n  .scheduled-demo h4 {\n    font-size: 14px;\n    line-height: 20px;\n  }\n  .scheduled-demo h3 {\n    font-size: 22px;\n    line-height: 28px;\n  }\n  .option p {\n    width: 250px;\n  }\n  .callender-left-wrapper {\n    padding: 20px 20px 20px 20px;\n  }\n  .slots-wrapper {\n    width: 80vw;\n  }\n  .scheduled-demo h3 {\n    padding-bottom: 5px;\n  }\n  .choose-slot {\n    width: 110px;\n  }\n  .next-wrapper {\n    width: 8rem;\n  }\n  .back-wrapper {\n    width: 8rem;\n  }\n  .custom-width {\n    width: 300px;\n  }\n  .callender-left-wrapper.confirmation-step {\n    padding: 20px;\n  }\n}\n/* @media (max-width: 400px) {\n  .calender-right-wrapper{\n    width: 36vh;\n  } */\n/* } */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
